import React from 'react';
import WorkflowTableContainer from '../containers/workflow-table.container';
import WorkflowCreateContainer from '../containers/workflow-create.container';
import WorkflowDetailsContainer from '../containers/workflow-details.container';
import WorkflowUpdateContainer from '../containers/workflow-update.container';
import TenantGuard from '@components/common/TenantGuard';

export const workflowRoutes = [
  {
    path: 'workflows',
    element: (
      <TenantGuard showHeader={false}>
        <WorkflowTableContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'workflows/create',
    element: (
      <TenantGuard showHeader={false}>
        <WorkflowCreateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'workflows/:id/update',
    element: (
      <TenantGuard showHeader={false}>
        <WorkflowUpdateContainer />
      </TenantGuard>
    ),
  },
  {
    path: 'workflows/:id',
    element: (
      <TenantGuard showHeader={false}>
        <WorkflowDetailsContainer />
      </TenantGuard>
    ),
  },
];

export default workflowRoutes;
